import { useState } from 'react';
import { Icon, Layout, RadioButton, Table } from '@vwfs-bronson/bronson-react';

import { financialFormat } from '../../../../helpers/financialFormat';
import { financialFormatWithHostDiscount } from '../../../../helpers/financialFormatWithHostDiscount';

export const Coberturas = ({ tarifasZurich, setCobertura }) => {
  const [openDetails, setOpenDetails] = useState([]);
  if (tarifasZurich == null || tarifasZurich.length == 0) return <></>;
  if (tarifasZurich[0].internalValue)
    return (
      <Layout.Item>
        <p>
          {tarifasZurich[0].internalValue === 'No existen aportaciones para el paquete actual'
            ? tarifasZurich[0].internalValue
            : 'Ocurrió un error al obtener las tarifas'}
        </p>
      </Layout.Item>
    );
  const TieneAportacion =
    tarifasZurich.filter((x) => x.grupoPaquetes[0]?.Aportaciones[0]?.NumeroCuotasAportacion > 0).length > 0
      ? true
      : false;

  if (!tarifasZurich || tarifasZurich.length === 0) {
    return (
      <Layout.Item>
        <p>No ha sido posible localizar coberturas.</p>
      </Layout.Item>
    );
  }
  return (
    <Layout.Item>
      <Table dataControls>
        <>
          <Table.Caption>Description of table content.</Table.Caption>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Paquete Comercial</Table.Th>
              <Table.Th>Cuota Mensual</Table.Th>
              {TieneAportacion && <Table.Th>Oferta Comercial</Table.Th>}
              <Table.Th>
                <Icon name={'semantic-info'} />
              </Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {tarifasZurich.map((tar, idx) => (
              <>
                <Table.Tr key={tar.grupoPaquetes[0]?.Codigo}>
                  <Table.Td>
                    <RadioButton name="radio-button-sample" onChange={() => setCobertura(tar)}>
                      {tar.ServiceName}
                    </RadioButton>
                  </Table.Td>
                  {/* Cuota mensual */}
                  <Table.Td>{financialFormat(tar.grupoPaquetes[0]?.Paquetes[0]?.ImporteNetoTarifa)} €/mes</Table.Td>
                  {/* Oferta comercial */}
                  {/* {TieneAportacion && (
                    <Table.Td>
                      {tar.grupoPaquetes[0]?.Aportaciones[0]?.NumeroCuotasAportacion} meses por{' '}
                      {financialFormat(tar.grupoPaquetes[0]?.Paquetes[0]?.ImporteBrutoCuota)}
                      {' €/mes'}
                    </Table.Td>
                  )} */}
                  {TieneAportacion && (
                    <Table.Td>
                      {tar.grupoPaquetes[0]?.Aportaciones[0]?.NumeroCuotasAportacion} meses por{' '}
                      {financialFormatWithHostDiscount(
                        tar.grupoPaquetes[0]?.Paquetes[0]?.ImporteNetoTarifa,
                        tar.grupoPaquetes[0]?.Aportaciones[0]?.PorcentajeAportacion,
                      )}
                      {' €/mes'}
                    </Table.Td>
                  )}
                  <Table.Td>
                    <span
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setOpenDetails((prev) => (prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]));
                      }}
                    >
                      <Icon name={openDetails.includes(idx) ? 'semantic-sort-asc' : 'semantic-sort-desc'} />
                    </span>
                  </Table.Td>
                </Table.Tr>
                {openDetails.includes(idx) && tar?.PaquetesDescription?.length > 0 && (
                  <Table.Tr>
                    <Table.Td colSpan={TieneAportacion ? 4 : 3}>
                      <ul style={{ margin: 0, paddingLeft: 20 }}>
                        {tar.PaquetesDescription.map((desc, i) => (
                          <li key={i}>{desc}</li>
                        ))}
                      </ul>
                    </Table.Td>
                  </Table.Tr>
                )}
              </>
            ))}
          </Table.Tbody>
        </>
      </Table>
    </Layout.Item>
  );
};
